import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DataContext } from "../../helper/HelperOne";
import axios from "axios";
import { toast } from "react-toastify";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { Dialog } from "@headlessui/react";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { EllipsisVerticalIcon, ShoppingBagIcon } from "lucide-react";
import LeadProductsList from "./LeadProductsList";
import LabelTopView from "../Utility/LabelTopView";
import TopStats from "../Utility/TopStats";
import TopFilters from "../Utility/TopFilters";
import UpdateConfirmation from "../Utility/UpdateConfirmation";

function LeadProductsCreate() {

      const [filterParams, setFilterParams] = useState(""); 
  

  const user = JSON.parse(localStorage.getItem("user"));
  const productPermission = user?.product_role_based_access?.some(
    (access) => access.label_id == 2 && access.label_value != 0
  );

  
  const userForEdit = JSON.parse(localStorage.getItem("user"));
  const productPermissionForEdit =
    userForEdit?.product_role_based_access?.some(
      (access) => access.label_id == 3 && access.label_value != 0
    );

  const location = useLocation();
  const [isEditing, setIsEditing] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [productsDialogOpen, setProductsDialogOpen] = useState(false);
  const [saveBtn, setSaveBtn] = useState("save");
  const { searchData } = useContext(DataContext);
  const [editProductIdCrypt, setEditProductIdCrypt] = useState("");
  const [productsInputs, setProductsInputs] = useState({
    product_name: "",
    product_type: "",
    code_type: "",
    product_cost: "",
    price_bill_type: "",
    count: "",
    product_description: "",
  });

  const headers = ["No", "Product", "Cost", "Count", "Action"];

  const [billTypes, setBillTypes] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [codeTypes, setCodeTypes] = useState([]);
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [editProduct, setEditProduct] = useState();
  const [paginationProductsDatas, setPaginationProductsDatas] = useState();
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);

  const [requiredFields, setRequiredFields] = useState({
    product_name: "",
    product_type: "",
    product_cost: "",
    price_bill_type: "",
    code_type: "",
    count:"",
    product_description: "",
  });

    const [filterData, setFilterData] = useState({
      product_name: "",
      count: "",
      product_cost: "",
    });

  const fetchData = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }
    setLoading(true);

    try {
      const [billResponse, productResponse, codeResponse, taxResponse] =
        await Promise.all([
          axios.get("public/api/admin/bill_type", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get("public/api/admin/product_type", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get("public/api/admin/code_type", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          // axios.get("public/api/admin/tax_type", {
          //   headers: { Authorization: `Bearer ${token}` },
          // }),
        ]);

      if (billResponse.data.success) setBillTypes(billResponse.data.bill_type);
      if (productResponse.data.success)
        setProductTypes(productResponse.data.product_type);
      if (codeResponse.data.success) setCodeTypes(codeResponse.data.code_type);
      // if (taxResponse.data.success) setTaxTypes(taxResponse.data.tax_type);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

 

  const fetchProducts = async (page = 1, queryParams = "") => {
    try {
        const token = localStorage.getItem("token");
        const productUrl = `public/api/admin/product/pagination?page=${page}${
            queryParams ? `&${queryParams}` : ""
        }${searchData ? `&search=${encodeURIComponent(searchData)}` : ""}`;



        const response = await axios.get(productUrl, {
            headers: { Authorization: `Bearer ${token}` },
        });

        setProducts(response.data.products.data);
        setPaginationProductsDatas(response.data.products);
        setCurrentPage(response.data.products.current_page);

    } catch (error) {
        console.error("Error fetching products:", error);
        return [];
    }
};


useEffect(() => {
  fetchProducts(currentPage, filterParams);
}, [searchData, currentPage, filterParams]);  // ✅ Updates when search/filter changes


  const handleAddTask = async () => {
    setLoading(true);
    setIsEditing(false);
    try {
      await fetchProducts();
      setProductsInputs({
        product_name: "",
        product_type: "",
        code_type: "",
        product_cost: "",
        price_bill_type: "",
        count: "",
        product_description: "",
      });
      setSaveBtn("save");
      setProductsDialogOpen(true);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  //handleChange for Product list with GST calculation
  const handleChangeForProducts = (e) => {
    const { name, value } = e.target;

    setProductsInputs((prevList) => ({
      ...prevList,
      [name]: value,
    }));

    if (name === "product_type") {
      const productTypeId = parseInt(value);

      if (productTypeId === 0) {
        setProductsInputs((prevList) => ({
          ...prevList,
          code_type: "HSN",
        }));
      } else if (productTypeId === 1) {
        setProductsInputs((prevList) => ({
          ...prevList,
          code_type: "SAC",
        }));
      }
    }
  };

  const handleSubmitForProducts = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await axios.post(
        "public/api/admin/product/store",
        productsInputs,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  

      if (response.data.success) {
        toast.success("Product added successfully");
        setProductsDialogOpen(false);
        await fetchProducts();
      } else if (response.data.success === false) {
        setErrors(response.data.message);
      }
    } catch (error) {
      if (error.response && error.response.data.errors) {
        setRequiredFields(error.response.data.errors);
      }
      console.error("Error adding product:", error.response.data.errors);
    } finally{
      setLoading(false)
    }
  };

  const handleEditForLeadTask = async (id_crypt) => {
    setLoading(true);
    setSaveBtn("update");
    setIsEditing(false);
    toast.success("Now You Can Edit This Customer");
    setProductsDialogOpen(true);
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.get(
        `public/api/admin/product/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if(response.data){
        setProductsInputs((prevList) => ({
          ...prevList,
          product_name: response.data.product.product_name,
          product_type: response.data.product.product_type,
          code_type: response.data.product.code_type,
          product_cost: response.data.product.product_cost,
          price_bill_type: response.data.product.price_bill_type,
          count: response.data.product.count,
          product_description: response.data.product.product_description,
        }))
      }

    } catch (err) {
      toast.error(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateForProducts = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `public/api/admin/product/update/${editProductIdCrypt}`,
        productsInputs,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Product updated successfully");
        setProductsDialogOpen(false);
        await fetchProducts();
      } else {
        toast.error("Failed to update product");
      }
    } catch (error) {
      console.error("Error updating product:", error);
      toast.error("Failed to update product due to an error.");
    }
  };

  const handleDialogClose = async () => {
    setLoading(true);
    try {
      await fetchProducts();
      setProductsDialogOpen(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const statsFieldNames = [
    {
      title: "Total Products",
      value: products.length,
      color: "blue",
      bg: "bg-blue-50",
      link: "/crm/employees",
    },
    {
      title: "Goods",
      value: products.filter((item) => item.code_type === "HSN").length,
      color: "green",
      bg: "bg-green-50",
      link: "/crm/employees/active",
    },
    {
      title: "Service",
      value: products.filter((item) => item.code_type === "SAC").length,
      color: "yellow",
      bg: "bg-yellow-50",
      link: "/crm/employees/inactive",
    },
  ];

  const fields = [
    {
      name: "product_name",
      type: "text",
      placeholder: "Enter Name",
      componentType: "select",
      options: products.map((product) => ({
        value: product.product_name,
        label: product.product_name,
      })),
    }
    ,    
    {
      name: "product_cost",
      type: "text",
      placeholder: "Enter Cost",
      componentType: "select",
      options: products.map((product) => ({
        value: parseInt(product.product_cost),
        label: parseInt(product.product_cost),
      })),
    },
  
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



const handleFilter = () => {
  const queryParams = new URLSearchParams();

  if (filterData.product_name?.trim()) {
      queryParams.append("product_name", filterData.product_name.trim());
  }
  if (filterData.count) {
      queryParams.append("count", filterData.count);
  }
  if (filterData.product_cost) {
      queryParams.append("product_cost", Number(filterData.product_cost).toFixed(2));
  }

  setFilterParams(queryParams.toString()); // ✅ Store query params
  fetchProducts(1, queryParams.toString()); // ✅ Fetch data with filters applied
};

  const handleReset = async () => {
    setFilterData({ product_name: "", count: "", product_cost: "" });
    await fetchProducts();
  };

  return (
    <>
      {loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : (
        
        <>
      <LabelTopView label="Product Overview" icon={<ShoppingBagIcon />} />
      <TopStats statsFieldNames={statsFieldNames} />


     


          <HeaderWithButton
            title="Products"
            description="products"
            buttonText="Products"
            onButtonClick={handleAddTask}
            showButton={productPermission}
          />

<TopFilters
        fields={fields}
        filterData={filterData}
        handleChange={handleChange}
        handleFilter={handleFilter}
        handleReset={handleReset}
      />  

          <LeadProductsList
            setLoading={setLoading}
            setIsEditing={setIsEditing}
            setSaveBtn={setSaveBtn}
            setProductsInputs={setProductsInputs}
            setEditProductIdCrypt={setEditProductIdCrypt}
            setProductsDialogOpen={setProductsDialogOpen}
            paginationProductsDatas={paginationProductsDatas}
            fetchProducts={fetchProducts}
            setCurrentPage={setCurrentPage}
            productPermission={productPermission}
            filterParams={filterParams}
          />

          {productsDialogOpen && (
            <Dialog
              open={productsDialogOpen}
              onClose={() => {}}
              className="relative z-10"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className=" flex min-h-full items-end justify-center p-4 text-center sm:items-center  md:min-h-screen sm:p-0">
                  <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto ">
                    <div
                      className="flex justify-between p-4 text-white sticky top-0"
                      style={{ backgroundColor: "#6366f1" }}
                    >
                      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium uppercase z-100">
                        Lead Management Task
                      </h1>
                      <div className="flex gap-2">
                       
                        {productPermissionForEdit &&isEditing && (
                          <div className="relative">
                            <button
                              type="button"
                              className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900"
                              aria-expanded={isOpenEdit}
                            >
                              <PencilSquareIcon
                                // onClick={() => setIsOpenEdit(!isOpenEdit)} // Toggle visibility
                                onClick={() => {
                                  handleEditForLeadTask(editProductIdCrypt);
                                  setIsOpenEdit(false); // Close after clicking Edit
                                }}
                                className="h-6 w-6 cursor-pointer text-white"
                              />
                            </button>

                            {/* {isOpenEdit && (
                              <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                                <div className="w-56 shrink rounded-xl bg-white p-4 text-sm/6 font-semibold text-gray-900 ring-1 shadow-lg ring-gray-900/5">
                                  <a
                                    href="#"
                                    className="block p-2 hover:text-indigo-600"
                                    onClick={() => {
                                      handleEditForLeadTask(editProductIdCrypt);
                                      setIsOpenEdit(false); // Close after clicking Edit
                                    }}
                                  >
                                    Edit
                                  </a>
                                </div>
                              </div>
                            )} */}
                          </div>
                        )}
                         <XMarkIcon
                          onClick={handleDialogClose}
                          className="h-6 w-6 cursor-pointer"
                        />
                      </div>
                    </div>

                    <div className="max-w-7xl mx-auto p-6 ">
                      <div className="md:grid md:gap-6">
                        <div className="md:mt-0 md:col-span-2">
                          <form>
                            <div className="overflow-hidden sm:rounded-md">
                              <div className="bg-white">
                                <div className="grid grid-cols-6 gap-6">
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="product_name"
                                      className="block  sm:text-md  text-sm font-medium leading-6 text-gray-900 "
                                    >
                                      Product Name
                                    </label>
                                    <div className="mt-2">
                                      <input
                                        name="product_name"
                                        type="text"
                                        value={productsInputs.product_name}
                                        onChange={handleChangeForProducts}
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border-0 py-1.5  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                        disabled={isEditing}
                                        placeholder="Product Name"
                                      />
                                    </div>
                                    {requiredFields.product_name && (
                                      <p className="mt-1 text-sm text-red-600">
                                        {requiredFields.product_name}
                                      </p>
                                    )}
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="product_type"
                                      className="block  sm:text-md  font-medium leading-6 text-gray-900"
                                    >
                                      Product Type
                                    </label>
                                    <div className="mt-2">
                                      <select
                                        name="product_type"
                                        value={productsInputs.product_type}
                                        onChange={handleChangeForProducts}
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                        disabled={isEditing}
                                        placeholder="Product Type"
                                      >
                                        <option value="">
                                          Select Product Type
                                        </option>
                                        <option value="0">Goods</option>
                                        <option value="1">Service</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="code_type"
                                      className="block  sm:text-md  font-medium leading-6 text-gray-900"
                                    >
                                      Code Type
                                    </label>
                                    <div className="mt-2">
                                      <select
                                        name="code_type"
                                        value={productsInputs.code_type}
                                        onChange={handleChangeForProducts}
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } border-gray-300  bg-gray-100 text-gray-500 cursor-not-allowed shadow-sm focus:border-gray-300 focus:ring-0 sm:text-sm`}
                                        disabled
                                        placeholder="Code Type"
                                      >
                                        <option value="">
                                          Select Code Type
                                        </option>

                                        <option value="HSN">HSN</option>
                                        <option value="SAC">SAC</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <div className="grid grid-cols-6 gap-6 mt-5">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="product_cost"
                                      className="block  sm:text-md  font-medium leading-6 text-gray-900"
                                    >
                                      Product Count
                                    </label>
                                    <div className="mt-2">
                                      <input
                                        name="count"
                                        type="number"
                                        value={productsInputs.count}
                                        onChange={handleChangeForProducts}
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                        disabled={isEditing}
                                        placeholder="Product Count"
                                      />
                                    </div>
                                    {requiredFields.count && (
                                      <p className="mt-1 text-sm text-red-600 ">
                                        {requiredFields.count}
                                      </p>
                                    )}
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="product_cost"
                                      className="block  sm:text-md  font-medium leading-6 text-gray-900"
                                    >
                                      Product Cost
                                    </label>
                                    <div className="mt-2">
                                      <input
                                        name="product_cost"
                                        type="number"
                                        value={productsInputs.product_cost}
                                        onChange={handleChangeForProducts}
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                        disabled={isEditing}
                                        placeholder="Product Cost"
                                      />
                                    </div>
                                    {requiredFields.product_cost && (
                                      <p className="mt-1 text-sm text-red-600 ">
                                        {requiredFields.product_cost}
                                      </p>
                                    )}
                                  </div>

                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="price_bill_type"
                                      className="block  sm:text-md  font-medium leading-6 text-gray-900"
                                    >
                                      Price Bill Type
                                    </label>
                                    <div className="mt-2">
                                      <select
                                        name="price_bill_type"
                                        value={productsInputs.price_bill_type}
                                        onChange={handleChangeForProducts}
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                        disabled={isEditing}
                                        placeholder="Select Bill Type"
                                      >
                                        <option value="">
                                          Select Bill Type
                                        </option>

                                        <option value="0">Purchase</option>
                                        <option value="1">Sales</option>
                                      </select>
                                      {requiredFields.price_bill_type && (
                                        <p className="mt-1 text-sm text-red-600 ">
                                          {requiredFields.price_bill_type}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="grid  gap-6 mt-5">
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="product_description"
                                      className="block  sm:text-md  font-medium leading-6 text-gray-900"
                                    >
                                      Product Description
                                    </label>
                                    <div className="mt-2">
                                      <textarea
                                        name="product_description"
                                        type="text"
                                        value={
                                          productsInputs.product_description
                                        }
                                        onChange={handleChangeForProducts}
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                        disabled={isEditing}
                                        placeholder="Product Description"
                                      />
                                    </div>
                                    {requiredFields.product_description && (
                                      <p className="mt-1 text-sm text-red-600">
                                        {requiredFields.product_description}
                                      </p>
                                    )}
                                  </div>
                                </div>

                                {/* Save Button */}
                              <div className="flex justify-end">
                              {saveBtn === "save" ? (
                                  <div className="bg-white mt-6 uppercase text-md">
                                    <button
                                      onClick={handleSubmitForProducts}
                                      className="inline-flex justify-center uppercase text-md py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Save
                                    </button>
                                  </div>
                                ) : (
                                  <div className="bg-white mt-6">
                                    {/* <button
                                      onClick={handleUpdateForProducts}
                                      className="inline-flex justify-center uppercase text-md py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Update
                                    </button> */}
                                     <UpdateConfirmation
                                    id_crypt={editProductIdCrypt}
                                    apiType="product"
                                    fetchClientData={fetchProducts}
                                    inputs={productsInputs}
                                    dialogClose={setProductsDialogOpen}
                                  />
                                  </div>
                                )}
                              </div>
                                
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </div>
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}

export default LeadProductsCreate;
